const CARD_SELECTOR = ".review-card";
const SWIPE_THRESHOLD_PX = 50;

function createDialog() {
  const dialog = document.createElement("dialog");
  dialog.className = "review-lightbox";
  dialog.setAttribute("aria-label", "รีวิว");
  dialog.innerHTML = `
    <button type="button" class="review-lightbox__close" aria-label="ปิด">
      <i class="fas fa-times"></i>
    </button>
    <button type="button" class="review-lightbox__nav review-lightbox__nav--prev" aria-label="รีวิวก่อนหน้า">
      <i class="fas fa-chevron-left"></i>
    </button>
    <img class="review-lightbox__image" alt="" />
    <button type="button" class="review-lightbox__nav review-lightbox__nav--next" aria-label="รีวิวถัดไป">
      <i class="fas fa-chevron-right"></i>
    </button>
    <p class="review-lightbox__counter"></p>
  `;
  document.body.appendChild(dialog);
  return dialog;
}

export function initReviewLightbox() {
  if (!document.querySelector(CARD_SELECTOR) && !document.getElementById("reviews-container")) return;
  if (typeof HTMLDialogElement !== "function") return;

  const dialog = createDialog();
  const image = dialog.querySelector(".review-lightbox__image");
  const counter = dialog.querySelector(".review-lightbox__counter");
  let cards = [];
  let currentIndex = 0;

  const show = (index) => {
    if (!cards.length) return;
    currentIndex = (index + cards.length) % cards.length;
    const source = cards[currentIndex].querySelector("img");
    image.src = source.currentSrc || source.src;
    image.alt = source.alt;
    counter.textContent = `${currentIndex + 1} / ${cards.length}`;
  };

  // Delegated so cards rendered later by reviews.js are also handled
  document.addEventListener("click", (event) => {
    const card = event.target.closest(CARD_SELECTOR);
    if (!card) return;
    cards = [...document.querySelectorAll(CARD_SELECTOR)];
    show(cards.indexOf(card));
    dialog.showModal();
  });

  dialog.querySelector(".review-lightbox__close").addEventListener("click", () => dialog.close());
  dialog.querySelector(".review-lightbox__nav--prev").addEventListener("click", () => show(currentIndex - 1));
  dialog.querySelector(".review-lightbox__nav--next").addEventListener("click", () => show(currentIndex + 1));

  // Clicks on the dialog element itself land on the backdrop area
  dialog.addEventListener("click", (event) => {
    if (event.target === dialog) dialog.close();
  });

  dialog.addEventListener("keydown", (event) => {
    if (event.key === "ArrowLeft") show(currentIndex - 1);
    if (event.key === "ArrowRight") show(currentIndex + 1);
  });

  let touchStartX = null;
  dialog.addEventListener("touchstart", (event) => {
    touchStartX = event.touches[0].clientX;
  }, { passive: true });
  dialog.addEventListener("touchend", (event) => {
    if (touchStartX === null) return;
    const deltaX = event.changedTouches[0].clientX - touchStartX;
    touchStartX = null;
    if (Math.abs(deltaX) < SWIPE_THRESHOLD_PX) return;
    show(deltaX > 0 ? currentIndex - 1 : currentIndex + 1);
  });

  dialog.addEventListener("close", () => {
    image.removeAttribute("src");
  });
}
